import { createStorageKeySchema } from '@dynamic-labs-sdk/client/core';
import * as z from 'zod/mini';

import { PHANTOM_SESSION_STORAGE_KEY } from '../../phantomRedirect.constants';

/**
 * Storage schema for persisting Phantom wallet session data.
 * This includes the encryption keys and session information needed
 * for subsequent operations after the initial connection.
 */
export const phantomSessionStorageKeySchema = createStorageKeySchema({
  key: PHANTOM_SESSION_STORAGE_KEY,
  schema: z.object({
    dappPublicKey: z.string(),
    dappSecretKey: z.string(),
    phantomPublicKey: z.string(),
    sessionToken: z.string(),
    sharedSecret: z.string(),
    walletAddress: z.string(),
  }),
});
